// @ts-nocheck
import {
  getForceLogoutFlag,
  getTokenContext,
  removeSyncingState,
  shouldSkipSync,
  syncWithLiveTokenContext
} from "./pw-sync-utils.js";

(function () {
  "use strict";

  function resolveRedirectUrl(redirectUrl) {
    // If redirect is home page, override with localStorage (preferences or selectedExamRedirectUrl)
    if (!redirectUrl || redirectUrl === "/") {
      try {
        const prefsRaw = localStorage.getItem("preferences");
        if (prefsRaw) {
          const prefs = JSON.parse(prefsRaw);
          if (prefs.redirection_url) {
            console.log("[PW Sync] Using preferences redirection_url:", prefs.redirection_url);
            return prefs.redirection_url;
          }
        }
        const storedRedirect = localStorage.getItem("selectedExamRedirectUrl");
        if (storedRedirect) {
          console.log("[PW Sync] Using localStorage redirect:", storedRedirect);
          return storedRedirect;
        }
      } catch (e) {}
    }

    return redirectUrl;
  }

  function syncTokenContext() {
    console.log("[PW Sync] Running syncTokenContext");

    const navigation = performance.getEntriesByType("navigation")[0];
    const isPageRefresh = navigation?.type === "reload";
    const isForceLogout = getForceLogoutFlag();

    const tokenContext = getTokenContext();
    const { stored, live, redirectUrl } = tokenContext;

    // 🔥 Apply redirect override logic here
    const finalRedirectUrl = resolveRedirectUrl(redirectUrl);

    if (shouldSkipSync({ storedContext: stored, liveTokenContext: live })) {
      removeSyncingState({
        shouldRedirect: true,
        redirectUrl: finalRedirectUrl
      });
      return;
    }

    syncWithLiveTokenContext({
      ...live,
      redirectUrl: finalRedirectUrl
    });
  }

  syncTokenContext();
  console.log("[PW Live Sync] Script initialized");
})();
